<template>
  <div class="center">
    <div class="left">
      <div class="json-tree left-center">
        <div class="json-viewer">
          <tree :data="json" :options="treeOptions" @node:selected="selectNode">
            <span :class="['viewer-type--' + node.data.type]" class="viewer-item" slot-scope="{ node }">
              <span
                class="viewer-item__key"
                v-if="node.hasChildren()"
              >
                <span class="viewer-item__key">
                  {{ node.text }}
                  <span class="viewer-item__array" v-if="node.data.array">[ ]</span>
                </span>
                <span v-if="node.collapsed()">
                  <template v-if="node.data.type == 'array'">[ {{ node.children.length }} ]</template>
                  <template v-else>{ {{ node.children.length }} }</template>
                </span>
              </span>
              <span class="viewer-item__prop" v-else>
                <span class="viewer-item__key">
                  {{ node.text }}
                  <span class="viewer-item__array" v-if="node.data.array">[ ]</span>
                </span>
                :
                <span class="viewer-item__value_bold">
                  <template v-if="node.text == 'apiVersion'">"{{ node.data.version }}"</template>
                  <template v-if="node.text == 'kind'">"{{ node.data.kind }}"</template>
                </span>
                <span class="viewer-item__value">
                  <template v-if="node.text != 'kind' && node.text != 'apiVersion'">{{ node.data.objectKey }}</template>
                </span>

              </span>
            </span>
          </tree>
        </div>
      </div>
      
      <div class="footer-text">
          <h3>项目的发展离不开你的支持，请作者喝杯咖啡吧！</h3>
          <h4 style="color:red;">留下邮箱还可以获得<br/>本项目前端源码和完整的 k8s api 结构化数据</h4>
          <h5><a href="mailto:abel533@gmail.com" style="text-decoration: none;">abel533@gmail.com</a></h5>
      </div>
      <div class="footer">
          <img src="https://mybatis.io/img/wx_pay.png" width="200"/>
          <img src="https://mybatis.io/img/ali_pay.png" width="200"/>
      </div>
    </div>
    <div class="right">
      <iframe id="api-html" src="./html/" width="100%" height="100%" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import LiquorTree from 'liquor-tree'
import { LiquorData } from '@/common/api-util'
import k8sApi from '@/assets/k8s-api-v1.29.json'

console.log('11111111111')

export default {
  name: 'JsonViewer',
  components: {
    [LiquorTree.name]: LiquorTree
  },
  data() {
    return {
      baseUrl: 'https://kubernetes.io/docs/reference/generated/kubernetes-api/v1.29/',
      json: LiquorData(k8sApi),
      treeOptions: {}
    }
  },

  methods: {
    selectNode(node) {
      if(node.data.id) {
        this.appendIdToIframeSrc(node.data.id)
      }
    },
    appendIdToIframeSrc(id) {
      const iframe = document.querySelector('#api-html')
      let src = iframe.getAttribute('src')
      if (src.includes('#')) {
        src = src.split('#')[0] + '#' + id
      } else {
        src += '#' + id
      }
      iframe.setAttribute('src', src)
    },
    isString(value) {
      return 'string' == typeof value
    },

    isNaN(value) {
      return value !== value
    },

    isBoolean(value) {
      return 'boolean' == typeof value
    },

    isNumber(value) {
      return 'number' == typeof value
    },

    isArray(value) {
      return Array.isArray(value)
    },

    isValue(value) {
      return !this.isArray(value) && !this.isPlainObject(value)
    },

    isPlainObject(value) {
      function isObject(obj) {
        return (
          obj != null && typeof obj === 'object' && Array.isArray(obj) === false
        )
      }

      if (
        !isObject(value) ||
        !value.constructor ||
        !value.constructor.prototype
      ) {
        return false
      }

      return (
        value.constructor.prototype.hasOwnProperty('isPrototypeOf') === true
      )
    },

    isIterable(value) {
      return this.isArray(value) || this.isPlainObject(value)
    },

    map(obj, fn) {
      return Object.keys(obj).map(key => {
        return fn(obj[key], key)
      })
    },

    transformObject(prop, key) {
      let obj = {
        text: key
      }

      if (this.isIterable(prop)) {
        obj.children = this.map(prop, this.transformObject)
        obj.data = {
          type: this.isArray(prop)
            ? 'array'
            : this.isPlainObject(prop)
            ? 'object'
            : 'unknown'
        }
      } else {
        obj.data = {
          objectKey: prop || `${prop}`,
          type: this.getType(prop)
        }
      }

      return obj
    },

    getType(value) {
      if (this.isNaN(value)) {
        return 'viewer-type--nan'
      }

      if (this.isString(value)) {
        return 'viewer-type--string'
      }

      if (this.isNumber(value)) {
        return 'viewer-type--integer'
      }

      if (this.isBoolean(value)) {
        return 'viewer-type--boolean'
      }

      if (null === value) {
        return 'viewer-type--null'
      }
    },

    parser(obj) {
      return [
        {
          text: 'JSONObject',
          state: { expanded: true },
          data: { type: 'root' },
          children: this.map(obj, this.transformObject)
        }
      ]
    }
  }
}
</script>

<style>
.center {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
}

.left {
  width: 450px;
  overflow: hidden;
}

.left .tree {
    height: calc(100vh - 400px);
    flex: 0 0 30%;
    background-color: rgba(51, 113, 227, 3%);
    overflow-y: auto;
    overflow-x: hidden;
}

.right {
    flex: 1;
    background-color: #eee;
}

.footer {
    height: 240px;
    background-color: rgba(51, 113, 227, 9%);
    display: flex; /* 设置为 flex 布局 */
    justify-content: space-around; /* 水平平均分布 */
    align-items: center; /* 垂直居中 */
}

.footer-text {
    height: 110px;
    text-align: center;
    margin: 0 auto;
    background-color: rgba(51, 113, 227, 9%);
}

.footer-text h3, .footer-text h4, .footer-text h5 {
    margin: 0;
    line-height: 1.7;
}

.viewer-item__key {
  color: #303030;
}

.viewer-item__key,
.viewer-item__ref,
.viewer-item__value {
  padding: 0 3px;
}

.viewer-item__value_bold {
  color: red;
}

.viewer-item__array {
  padding: 0 5px;
}

.viewer-item__ref a {
  text-decoration: none;
}
.viewer-item__ref a:active {
  text-decoration: none;
}

.viewer-type--boolean .viewer-item__value {
  color: #ff9b21;
}

.viewer-type--integer .viewer-item__value {
  color: #f85441;
}

.viewer-type--null .viewer-item__value {
  color: #acabab;
}

.viewer-type--string .viewer-item__value {
  color: green;
}

.viewer-type--object .viewer-item__value {
  color: #8080f5;
}

.api-link {
  color: #3371e3;
  text-decoration: underline;
}
</style>
